"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/CallContent.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _VideoFeed = require('web/components/VideoCall/VideoFeed'); var _VideoFeed2 = _interopRequireDefault(_VideoFeed);













const CallContent = ({
  isJoining,
  isPendingApproval,
  activeSpeakerVideoStream,
  isActiveSpeakerFeedOn,
  amISharingScreen,
  stopScreenSharing,
  areCallControlsActive,
  isCallMinimized,
  shouldMirrorActiveSpeakerFeed,
}) => {
  if (isJoining || isPendingApproval) {
    return (
      _react2.default.createElement('div', { className: "video-call--call-status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        , _react2.default.createElement('div', { className: "video-call--call-status-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
          , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
        )
        ,  isPendingApproval
          ? "Waiting for admin to join..."
          : "Joining the video call..."
        
      )
    )
  }

  if (amISharingScreen) {
    return (
      _react2.default.createElement('div', { className: "video-call--sharing-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
        , _react2.default.createElement('img', {
          src: "/assets/icons/video/screen-share-white.svg",
          className: "video-call--sharing-notice--icon",
          alt: "🖵", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
        )
        , _react2.default.createElement('span', { className: "video-call--sharing-notice--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "You are screen sharing."

        )
        , _react2.default.createElement('a', {
          onClick: stopScreenSharing,
          className: "video-call--sharing-notice--stop-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
, "End Screen Sharing"

        )
      )
    )
  }

  if (isActiveSpeakerFeedOn) {
    return (
      _react2.default.createElement(_VideoFeed2.default, {
        shouldMirror: shouldMirrorActiveSpeakerFeed,
        stream: activeSpeakerVideoStream,
        className: "video-call--call-feed", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
      )
    )
  }

  const stubIconWrapperClassName = _classBuilder2.default.call(void 0, 
    "video-call--call-feed-stub--wrapper",
    { shifted: areCallControlsActive },
    { mini: isCallMinimized },
  )
  return (
    _react2.default.createElement('div', { className: stubIconWrapperClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
      , _react2.default.createElement('img', {
        className: "video-call--call-feed-stub",
        src: "/assets/icons/video/coworker-grey.svg",
        alt: "Ǵ", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}
      )
    )
  )
}

exports. default = CallContent
